import React, { useEffect } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import config from 'react-global-configuration';
import classNames from 'classnames';

import { ENTITY_LOADING_STATUS_LOADING, ENTITY_LOADING_STATUS_START } from '@uncinc/react-drupal-core';

const OFFSET_ANCHOR_LINKS_KP = 120;

import './style.scss';

const Page = ({ children, className, loading, referenceLoading, title, ...props }) => {
  const dispatch = useDispatch();
  const domain = config.get('CURRENT_DOMAIN');
  const hasLoadingItems = referenceLoading.get('itemsStarted') > 0;
  const isLoading = hasLoadingItems && referenceLoading.get('itemsStarted') !== referenceLoading.get('itemsFinished');

  const classes = classNames(className, 'Page');
  const contentWrapperClasses = classNames('page--inner-wrapper', {
    'has-loading-items': hasLoadingItems,
    loading: isLoading,
  });


  const entityLoadingStatus = useSelector((state) => state.getIn(['entity', 'loadingStatus']));
  const entityLoading = (entityLoadingStatus === ENTITY_LOADING_STATUS_START || entityLoadingStatus === ENTITY_LOADING_STATUS_LOADING);

  useEffect(() => {
    if (!entityLoading && window.location.hash) {
      // Linking to hash from external does not seem to work with React(router?)
      // This is a simple workaround.
      //
      // Setting the window href makes the browser do the scrolling.
      // This way we don't need to do querySelectors and scrollTo functions
      setTimeout(() => {
        window.location.href = window.location.hash;
      }, 800);
      return;
    }

    window.scrollTo(0, 0);
  }, [title]);

  return (
    <div className={classes}>
      <div className={contentWrapperClasses}>
        {children}
      </div>
    </div>
  );
};

/**
 * @param state
 */
function mapStateToProps(state) {
  return {
    referenceLoading: state.getIn(['ui', 'referenceLoading']),
  };
}


export default connect(mapStateToProps)(Page);
